import { CoordinatorService } from './coordinator.service';
import { ScriptHitset } from './script-hitset';
import { SCRIPT_TARGET_TYPE } from './script-types';

export class ScriptBase {
    #coords: CoordinatorService;
    #target?: SCRIPT_TARGET_TYPE;

    constructor(coords: CoordinatorService, target?: SCRIPT_TARGET_TYPE) {
        this.#coords = coords;
        this.#target = target;
    }

    get id() {
        return this.#target!.id;
    }

    get title() {
        return this.#target!.title;
    }

    get target(): any {
        console.log('SCRIPT BASE TARGET', this);
        return undefined;
    }

    protected _hitset(nH: ScriptHitset, s: Set<string>, isParentFromPreview = false) {
        const dt = nH.isPreview ? this.#coords.dataset$.preview : this.#coords.dataset$.main;
        s = dt.existingIdSet(s);

        if (nH.isPreview && !isParentFromPreview)
            s = new Set(this.#coords.dataset$.fromMain2PreviewIdLs(s));
        else if (!nH.isPreview && isParentFromPreview)
            s = new Set(this.#coords.dataset$.fromPreview2MainIdLs(s));

        nH.idSet = s;
        nH.parent = this;
        return nH;
    }
}
